import CardPage5 from "./cardPage5";
import Title5 from "./title5";

export default function Page5(){
    return(
    <>
    <Title5/>
    <CardPage5/>
    </>
    )
}